// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__pNnYO","rewards":"styles_rewards__5y6d3","active":"styles_active__jk7c_","preview":"styles_preview__PDx_2"};